"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFriendsMap = exports.findTopCommonFriends = exports.getDefaultTopFriend = void 0;
const Participant_1 = require("../model/Participant");
const getDefaultTopFriend = () => ({
    rootName: "Default Top Friend",
    nth: 0,
    totalLength: 0,
    totalCommonLessons: 0,
    friends: [],
});
exports.getDefaultTopFriend = getDefaultTopFriend;
const findTopCommonFriends = (lessons) => {
    const friendMap = exports.createFriendsMap(lessons);
    const friends = Object.entries(friendMap)
        .map(([friendName, theirFriends]) => ({
        rootName: friendName,
        totalCommonLessons: Object.values(theirFriends).reduce((acc, curr) => acc + curr.length, 0),
        friends: Object.entries(theirFriends)
            .map(([deepFriendName, commonLessons]) => ({
            name: deepFriendName,
            commonLessonsLen: commonLessons.length,
            commonLessons,
        }))
            .sort((A, B) => B.commonLessons.length - A.commonLessons.length),
    }))
        .sort((A, B) => B.totalCommonLessons - A.totalCommonLessons)
        .map((friend, nth, { length: totalLength }) => (Object.assign({ nth,
        totalLength }, friend)));
    return friends;
};
exports.findTopCommonFriends = findTopCommonFriends;
const createFriendsMap = (lessons, friendKindsToInclude = Participant_1.getAllParticipantLabels()) => {
    const friendMap = {};
    for (const lesson of lessons) {
        if (lesson.isEmpty) {
            continue;
        }
        const from = [
            ...lesson.students,
            ...lesson.classes,
            ...lesson.teachers,
            ...lesson.rooms,
        ];
        const to = [
            ...(friendKindsToInclude.includes("student") ? lesson.students : []),
            ...(friendKindsToInclude.includes("class") ? lesson.classes : []),
            ...(friendKindsToInclude.includes("teacher") ? lesson.teachers : []),
            ...(friendKindsToInclude.includes("room") ? lesson.rooms : []),
        ];
        for (const A of from) {
            if (!friendMap[A]) {
                friendMap[A] = {};
            }
            for (const B of to) {
                if (A === B) {
                    continue;
                }
                if (!friendMap[A][B]) {
                    friendMap[A][B] = [];
                }
                if (!friendMap[A][B].includes(lesson.id)) {
                    friendMap[A][B].push(lesson.id);
                }
            }
        }
    }
    return friendMap;
};
exports.createFriendsMap = createFriendsMap;
//# sourceMappingURL=findTopFriends.js.map